import authModalLoader from '../src/utils/AuthModalLoader.js';

export default authModalLoader;
